import React, { lazy, Suspense } from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'

import * as latestVideosStyles from './latestVideos.module.scss'

const VideoFrame = lazy(() => import("./VideoFrame"));

const LatestVideos = () => {
    const data = useStaticQuery(graphql`
        query {
            allYoutubeVideo (limit: 3, sort: {
            publishedAt: DESC
            }) {
                edges {
                    node {
                        title
                        videoId
                    }
                }
            }
        }
    `)
    return (
        <div>
            <div className={latestVideosStyles.container}>
                <h2 className={latestVideosStyles.heading}>Watch</h2>
                <h3 className={latestVideosStyles.subheading}>Most recent videos</h3>
                <div className={latestVideosStyles.videos}>
                    {data.allYoutubeVideo.edges.map((edge) => {
                        return (
                            <div key={edge.node.title} className={latestVideosStyles.videoBlock}>
                                <Suspense fallback={<div>Loading...</div>}>
                                    <VideoFrame height="173" width="308" className={latestVideosStyles.video} title={edge.node.title} src={`https://www.youtube.com/embed/${edge.node.videoId}`} ></VideoFrame>
                                    <h4 className={latestVideosStyles.videoTitle}>{edge.node.title}</h4>
                                </Suspense>
                            </div>
                        )
                    })}
                    
                </div>
                <Link to="/videos">
                        <button className={`btn-color ${latestVideosStyles.button}`}>More Videos</button>
                    </Link>
            </div>
        </div>
    )
}

export default LatestVideos